import { useRef } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { OrbitControls, useTexture } from '@react-three/drei';
import * as THREE from 'three';

const CAMERA_DISTANCE = 16;

function Planet() {
  const texture = useTexture('/earth-v1.webp');

  const planetRef = useRef<THREE.Mesh | null>(null);
  const RADIUS = 4.5;

  useFrame(() => {
    if (planetRef.current) {
      planetRef.current.rotation.y += 0.0015;
    }
  });

  return (
    <group rotation={[0.4, -0.6, 0]}>
      <mesh ref={planetRef}>
        <sphereGeometry args={[RADIUS, 128, 128]} />
        <meshStandardMaterial map={texture} roughness={0.45} metalness={0.05} />
      </mesh>
    </group>
  );
}

export default function Scene() {
  return (
    <Canvas camera={{ position: [0, 0, CAMERA_DISTANCE], fov: 35 }}>
      <ambientLight intensity={0.25} />

      <directionalLight
        position={[-10, 10, 10]}
        intensity={1.9}
        color="#ffffff"
      />

      <directionalLight
        position={[8, -6, -4]}
        intensity={0.6}
        color="#123b7a"
      />

      <Planet />

      <OrbitControls
        enableZoom={false}
        enablePan={false}
        minDistance={CAMERA_DISTANCE}
        maxDistance={CAMERA_DISTANCE}
        enableRotate
      />
    </Canvas>
  );
}
